import { callPlanet } from './'

// export type FetchTranslationsApiResponse = {|
//   +[string]: string
// |}

export const translationsCall = (
  locale,
  partner
) => {
  return callPlanet(`translations/${partner}/${locale}`)
}
